<div class="container">
    <div id="home_nav" class="row">
        <div class="col-md-12">
            <ol class="breadcrumb loginMenu">
                <li class="breadcrumb-item">
                    <a class="bd-crumb-inactive" (click)="handleNavigation('home')">
                        {{i18n._value['shp.passwordReset.home']}}</a>
                </li>
                <li class="breadcrumb-item active">
                    {{i18n._value['shp.passwordReset.updatePassword']}}
                </li>
            </ol>
            <div class="text-align">{{i18n._value['shp.passwordReset.updatePassword']}}</div>
        </div>

    </div>
    <div class="row justify-content-md-center loginpanel">
        <div class="col-md-4 col-md-offset-4 lg-signBoxDiv">
            <div class="card login-card">
                <div class="card-header login-card-header">{{i18n._value['shp.passwordReset.setNewPassword']}}</div>
                <div class="card-body login-card-body">
                    <form name="form" [formGroup]="form">
                        <fieldset class="form-group">
                            <div class="form-group">
                                <label for="password">{{i18n._value['shp.passwordReset.newPassword']}}</label>
                                <div class="input-group mb-3">
                                        <span class="input-group-text">
                                            <i class="fa fa-lock"></i>
                                        </span>
                                    <input _ngcontent-c0="" class="input form-control" placeholder="New Password"
                                        type="password" id="password" formControlName="newPassword" />
                                </div>
                                <span *ngIf="f.newPassword.invalid && f.newPassword.touched" class="help-block1"
                                style="color: #f32121">{{errorMessage}}</span>
                            </div>
                        </fieldset>
                        <fieldset class="form-group">
                            <div class="form-group">
                                <label for="password">{{i18n._value['shp.passwordReset.confirmPassword']}}</label>
                                <div class="input-group mb-3">
                                        <span class="input-group-text"><i class="fa fa-lock"></i></span>
                                    <input _ngcontent-c0="" class="input form-control" placeholder="Confirm Password"
                                        type="password" id="cpassword" formControlName="confirmPassword" />
                                    <span *ngIf="f.confirmPassword.touched && f.confirmPassword.invalid"
                                        class="help-block1"
                                        style="color: #f32121">{{i18n._value['shp.passwordReset.error']}}</span>
                                </div>
                            </div>
                        </fieldset>
                        <div class="row">
                            <div class="col-sm-12 text-right d-flex justify-content-end">
                                <button type="submit button" (click)="ResetPassword()"
                                    class=" btn btn-xs btn-light login-btn"
                                    [disabled]="!form.valid">{{i18n._value['shp.passwordReset.click']}}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>